export default __webpack_public_path__ + "static/media/Group89.ba9b308b.png";